import ActionTypes from "../../../../constants/ActionTypes";
import {
  IRequestFetchAcceptanceDataAction, IRequestGiveAcceptanceAction, ISetAcceptanceOptionNameAction,
  ISetAcceptanceSoftOfferPackageAction, ISetAcceptanceTermsAction,
  ISetCampaignAcceptanceDataAction, ISetCampaignAcceptanceStatusAction
} from "./types";

export function requestFetchAcceptanceDataAction(params: object): IRequestFetchAcceptanceDataAction {
  return {
    type: ActionTypes.CAMPAIGN.ACCEPTANCE.FETCH,
    params,
  };
}

export function requestGiveAcceptanceAction(params: object): IRequestGiveAcceptanceAction {
  return {
    type: ActionTypes.CAMPAIGN.ACCEPTANCE.GIVE_ACCEPTANCE,
    params,
  };
}

export function setCampaignAcceptanceDataAction(payload: object): ISetCampaignAcceptanceDataAction {
  return {
    type: ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_DATA,
    payload,
  };
}

export function setAcceptanceSoftOfferPackageAction(payload: object): ISetAcceptanceSoftOfferPackageAction {
  return {
    type: ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_OFFER_PACKAGE,
    payload,
  };
}

export function setAcceptanceOptionNameAction(payload: string): ISetAcceptanceOptionNameAction {
  return {
    type: ActionTypes.CAMPAIGN.ACCEPTANCE.SET_ACCEPTANCE_OPTION_NAME,
    payload,
  };
}

export function setCampaignAcceptanceStatusAction(status: boolean): ISetCampaignAcceptanceStatusAction {
  return {
    type: ActionTypes.CAMPAIGN.ACCEPTANCE.SET_STATUS,
    status,
  };
}

export function setAcceptanceTermsAction(payload: string): ISetAcceptanceTermsAction {
  return {
    type: ActionTypes.CAMPAIGN.ACCEPTANCE.SET_TERMS,
    payload,
  };
}

